import {
  ChevronLeftRounded,
  ChevronRightRounded,
  EditNoteRounded,
  FormatQuoteRounded,
} from '@mui/icons-material';
import {
  alpha,
  Box,
  Button,
  Chip,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import {
  ButtonBack,
  ButtonNext,
  CarouselProvider,
  Slide,
  Slider,
} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { CategoryIcon } from '../CategoryIcon';
import { REASON_DESCRIPTION_GUIDE } from './constants';

export const ReasonDescriptionGuide = () => {
  return (
    <Paper sx={{ mt: 2 }}>
      <CarouselProvider
        naturalSlideWidth={1112}
        naturalSlideHeight={220}
        totalSlides={REASON_DESCRIPTION_GUIDE.length}
        infinite
        dragEnabled={false}
      >
        <Box position="relative">
          <Slider>
            {REASON_DESCRIPTION_GUIDE.map(
              ({ reasonName, description, category }, index) => (
                <Slide index={index} key={index}>
                  <Box
                    sx={{
                      left: 0,
                      right: 0,
                      margin: 'auto',
                      maxWidth: 800,
                      width: '70%',
                      position: 'relative',
                      top: '50%',
                      transform: 'translateY(-50%)',
                    }}
                  >
                    <Stack
                      border={0.5}
                      borderColor={(theme) =>
                        alpha(theme.palette.secondary.dark, 0.6)
                      }
                      borderRadius={1}
                      height="100%"
                    >
                      <Stack spacing={1} p={1.5}>
                        <Typography color="secondary" variant="caption">
                          <FormatQuoteRounded
                            fontSize="inherit"
                            sx={{ mr: 0.5 }}
                          />
                          Reason Name
                        </Typography>
                        <Stack direction="row" spacing={1}>
                          <Typography variant="body1">{reasonName}</Typography>
                          <Chip
                            icon={
                              <Box sx={{ ml: 2, mb: 0.5 }}>
                                <CategoryIcon category={category} size={12} />
                              </Box>
                            }
                            size="small"
                            label={category}
                          />
                        </Stack>
                      </Stack>
                      <Stack
                        bgcolor={(theme) =>
                          alpha(theme.palette.primary.dark, 0.08)
                        }
                        spacing={1}
                        p={1.5}
                      >
                        <Typography color="secondary" variant="caption">
                          <EditNoteRounded
                            fontSize="inherit"
                            sx={{ mr: 0.5 }}
                          />
                          Description
                        </Typography>
                        <Stack direction="row" spacing={1}>
                          <Typography variant="body2">{description}</Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                  </Box>
                </Slide>
              ),
            )}
          </Slider>
          <ButtonBack
            style={{
              all: 'unset',
              position: 'absolute',
              left: '10%',
              top: '45%',
            }}
          >
            <Button
              variant="outlined"
              size="small"
              sx={{ borderRadius: '50%', minWidth: 0, padding: 0.5 }}
            >
              <ChevronLeftRounded />
            </Button>
          </ButtonBack>
          <ButtonNext
            style={{
              all: 'unset',
              position: 'absolute',
              right: '10%',
              top: '45%',
            }}
          >
            <Button
              variant="outlined"
              size="small"
              sx={{ borderRadius: '50%', minWidth: 0, padding: 0.5 }}
            >
              <ChevronRightRounded />
            </Button>
          </ButtonNext>
        </Box>
      </CarouselProvider>
    </Paper>
  );
};
